
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7p1sh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $79b4274f634e19fa$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fe6e09ea53e7fa3fa7d8ba2613e2fb7>>
 * @codegenCommand yarn build tokens
 */ var $79b4274f634e19fa$export$2e2bcd8739ae039 = `
html[data-theme~="spacing:spacing"], [data-subtree-theme][data-theme~="spacing:spacing"] {
  --ds-space-0: 0rem;
  --ds-space-025: 0.125rem;
  --ds-space-050: 0.25rem;
  --ds-space-075: 0.375rem;
  --ds-space-100: 0.5rem;
  --ds-space-150: 0.75rem;
  --ds-space-200: 1rem;
  --ds-space-250: 1.25rem;
  --ds-space-300: 1.5rem;
  --ds-space-400: 2rem;
  --ds-space-500: 2.5rem;
  --ds-space-600: 3rem;
  --ds-space-800: 4rem;
  --ds-space-1000: 5rem;
  --ds-space-negative-025: -0.125rem;
  --ds-space-negative-050: -0.25rem;
  --ds-space-negative-075: -0.375rem;
  --ds-space-negative-100: -0.5rem;
  --ds-space-negative-150: -0.75rem;
  --ds-space-negative-200: -1rem;
  --ds-space-negative-250: -1.25rem;
  --ds-space-negative-300: -1.5rem;
  --ds-space-negative-400: -2rem;
}
`;

});


//# sourceMappingURL=atlassian-spacing.93c3e5de.js.map
